import { render, staticRenderFns } from "./category-brand-legal.vue?vue&type=template&id=820c8e18&"
import script from "./category-brand-legal.vue?vue&type=script&lang=js&"
export * from "./category-brand-legal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports